// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_r9-0";